<nb-card>
    <nb-card-body>

      <table [nbTreeGrid]="source" equalColumnWidth>
        
        <!-- Header Row-->
        <tr nbTreeGridHeaderRow *nbTreeGridHeaderRowDef="allColumns"></tr>
      <tr nbTreeGridRow  [clickToToggle]=clickToggle *nbTreeGridRowDef="let row; columns: allColumns" 
      [style.color]="row.data.__color || '#000'"
      [style.background-color]="row.data.__bgColor || '#fff'"
      [ngStyle]="{ 'font-weight':getWeight(row.data)}"></tr>

      <!-- Index Column Header-->
        <ng-container [nbTreeGridColumnDef]="customColumn">
          <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef 
          [style.color]="headercolor" class='idx-col'>
          <div class="chckbx-flex">
          <slot *ngIf="!checkboxes; else headerElseBlock">
            <div class="chckbx-flex-child no-checkbx">
                {{customColumn}}
              </div>
          </slot>
          <ng-template #headerElseBlock>
              <slot>
                  <div class="chckbx">
                  <nb-checkbox [checked]="checklistSelection.selected.length > 0" 
                  (change)="this.checkAllChange($event)"
                  [indeterminate]="checklistSelection.selected.length > 0 &&
                  checklistSelection.selected.length < this.datajson.length"
                  [status]="status">
                </nb-checkbox>
              </div>
              <div class="chckbx-flex-child chckbx-txt">{{customColumn}}</div>
            </slot>
          </ng-template>
        </div>
          </th>

          <!-- Index Column Cells-->
          <td nbTreeGridCell  *nbTreeGridCellDef="let row;" class='idx-col'>
          <div class="chckbx-flex" [ngClass]="{'childCell': !row.hasChildren()}">
            <div>
            <button nbTreeGridRowToggle
                      *ngIf="row.hasChildren()"
                      [attr.aria-label]="row.expanded ? 'collapse' : 'expand'">
                <nb-icon [icon]="row.expanded ? 'chevron-down-outline' : 'chevron-right-outline'"
                         aria-hidden="true">
                </nb-icon>
            </button>
            </div>
            <!-- <nb-tree-grid-row-toggle
              [expanded]="row.expanded === 'true'"
              *ngIf="row.data.children">
            </nb-tree-grid-row-toggle> -->
            <slot *ngIf="!checkboxes; else elseBlock">
              <div class="chckbx-flex-child no-checkbx">
              {{row.data.name}}
              </div>
            </slot>
            <ng-template #elseBlock>
              <slot>
                  <div class="chckbx">
                  <nb-checkbox [checked]="row.hasChildren() ? childrenAllSelected(row) : getCheckStatus(row)" 
                  (change)= "row.hasChildren() ? parentSelectionToggle(treeControl[row.data.idx]) : childSelectionToggle(treeControl[row.data.parentIdx].children[row.data.idx])"
                  [indeterminate]="row.hasChildren() ? childrenPartiallySelected(treeControl[row.data.idx]) : false"
                  [status]="status">
                </nb-checkbox>
              </div>
              <div class="chckbx-flex-child chckbx-txt">{{row.data.name}}</div>
            </slot>
            </ng-template>
          </div>
          </td>
        </ng-container>

        <ng-container *ngFor="let column of defaultColumns" [nbTreeGridColumnDef]="column">
            <th nbTreeGridHeaderCell *nbTreeGridHeaderCellDef [style.color]="headercolor">{{column}}</th>
          <td nbTreeGridCell *nbTreeGridCellDef="let row">{{row.data[column]}}</td>
        </ng-container>

      </table>

    </nb-card-body>
  </nb-card>